import { createStore } from 'owa-satcheljs';
import type { AppHostStore } from './schema/AppHostStore';
import type AppHostViewState from './schema/AppHostViewState';

let storeGetter: ReturnType<typeof createStore<AppHostStore>> | undefined;

function initializeAppHostStore() {
    if (!storeGetter) {
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        storeGetter = createStore<AppHostStore>('AppHostStore', {
            sharePointSiteInfo: new Map(),
            viewStates: new Map<string, AppHostViewState>(),
            primaryAppHostId: undefined,
        });
    }
}

export default function getAppHostStore(): AppHostStore {
    initializeAppHostStore();
    if (!storeGetter) {
        throw new Error('Store getter is not initialized.');
    }
    return storeGetter();
}
